import { render, staticRenderFns } from "./cLandingMetabaseFrame.vue?vue&type=template&id=41289566&scoped=true"
import script from "./cLandingMetabaseFrame.vue?vue&type=script&lang=js"
export * from "./cLandingMetabaseFrame.vue?vue&type=script&lang=js"
import style0 from "./cLandingMetabaseFrame.vue?vue&type=style&index=0&id=41289566&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41289566",
  null
  
)

export default component.exports